const routes = {
  authCallback: '/callback/:country?',
  home: '/',
  viewFormByName: '/:name',
  viewFormByCompanyAndName: '/:code/:name',
};

export default routes;
